var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(4 4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.218-864.764a1.168,1.168,0,0,1-.852-.365,1.168,1.168,0,0,1-.365-.852V-878.22h1.218v12.238h9.62v1.218Zm2.435-2.435a1.168,1.168,0,0,1-.852-.365,1.168,1.168,0,0,1-.365-.852v-11.365a1.168,1.168,0,0,1,.365-.852,1.168,1.168,0,0,1,.852-.365h8.93a1.168,1.168,0,0,1,.852.365,1.168,1.168,0,0,1,.365.852v11.365a1.168,1.168,0,0,1-.365.852,1.168,1.168,0,0,1-.852.365Zm0-1.218h8.93v-11.365h-8.93Zm0,0v0Z",
    transform: "translate(-115 885)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySprite);
export default __webpack_public_path__ + "static/media/copy_sprite.40ef4d251779325fe6a1defc8ea45022.svg";
export { ForwardRef as ReactComponent };